import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, FormControl, InputLabel, MenuItem, Select, TextField, Typography, makeStyles } from "@material-ui/core";
import RegularButton from "components/CustomButtons/Button";
import GridItem from "components/Grid/GridItem";
import Snackbar from "components/Snackbar/Snackbar";
import { useForm } from "hooks/useForm";
import { useOpenComponent } from "hooks/useOpenComponent";
import { useSearch } from "hooks/useSearch";
import styled from "styled-components";
import { FormContainer } from "views/Crm/styles";
import { selectDateMenuStyles } from "views/Expenses/styles";
import {
  handleNewValuesFunction, handleSelecTypeServiceFunction, handleSelecUnitfunction,
  handleSelectPermissionFunction, handleSelectUnitCodeFunction, handleSubmitFunction
} from "./utilsAddShipperTruck";
import { editShipperTruck, addShipperTruck } from "redux/actions/shipperTrucks/shipperTrucksAction";

const FormRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

const trucks = [
  { value: "REMOLQUE", label: "REMOLQUE" },
];

const permissionTruck = [
  { value: "PG", label: "PG" },
  { value: "FZ", label: "FZ" },
  { value: "PR", label: "PR" },
];

const trailerCode = [
  { value: "CTR021", label: "CTR021" },
  { value: "CTR028", label: "CTR028" },
];

const typeServiceGas = [
  { value: "GAS_LP", label: "GAS_LP" },
];

const useStyles = makeStyles(selectDateMenuStyles);

export const AddShipperTruck = (props) => {
  const { handleClose } = props;
  const classes = useStyles();
  const [truck, setTruck] = useState("");
  const [permission, setPermission] = useState("");
  const [typeofService, setTypeService] = useState("");
  const { shipperTruckSelected, addshipperTruckMode } = useSelector(state => state.PG);
  const [codeUnit, setCodeUnit] = useState("");
  const { inputValues, handleInputOnChange, handleNewValues } = useForm({
    type: "",
    economicNumber: "",
    license: "",
    capacity: "",
    plates: "",
    permissionSCT: "",
    model: "",
    permissionShipperTruck: "",
    cargoInsurance: "",
    civilLiabilityInsurance: "",
    environmentalInsurance: "",
    compartmen: "",
    trailerCodeSAT: "",
    typeService: ""
  });
  const dispatch = useDispatch();
  const { economicNumber, license, capacity, plates, permissionSCT, model, cargoInsurance, civilLiabilityInsurance, environmentalInsurance, compartmen } = inputValues;
  const { isOpen: openValues, handleIsOpen: handleOpenValues } = useOpenComponent();
  const {
    setSnackbar,
    clearSnackbar,
  } = useSearch();

  const handleSubmit = () => handleSubmitFunction(economicNumber, setSnackbar, truck, capacity, cargoInsurance, civilLiabilityInsurance, environmentalInsurance, plates, model, permissionSCT, license, compartmen,
    typeofService, permission, codeUnit, shipperTruckSelected, addshipperTruckMode, dispatch, addShipperTruck, handleClose, editShipperTruck, handleOpenValues);

  const handleSelectPermission = (value) => handleSelectPermissionFunction(setPermission, value);
  const handleSelectUnitCode = (value) => handleSelectUnitCodeFunction(setCodeUnit, value);
  const handleSelecTypeService = (value) => handleSelecTypeServiceFunction(value, setTypeService);
  const handleSelecUnit = (value) => handleSelecUnitfunction(value, setTruck);

  useEffect(() => {
    handleNewValuesFunction(shipperTruckSelected, handleNewValues, setTruck, setPermission, setCodeUnit, setTypeService);
  }, [shipperTruckSelected]);

  return (
    <>
      <Typography color="primary" id="modal-modal-title" variant="h4">
        {
          addshipperTruckMode
            ? "Nuevo PG"
            : "Modificar PG"
        }
      </Typography>
      <FormContainer onSubmit={handleSubmit}>
        <GridItem>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box mr={1}>
              <TextField type="text" fullWidth label="Numero Economico *" name="economicNumber" value={economicNumber} onChange={handleInputOnChange} />
              <FormControl fullWidth>
                <InputLabel>Tipo de unidad*</InputLabel>
                <Select
                  id="demo-simple-select-outlined"
                  value={truck}
                  onChange={(e) => handleSelecUnit(e.target.value)}
                  label="Tipo*"
                >
                  <MenuItem value="">
                    <em>Seleccione el tipo de la unidad</em>
                  </MenuItem>
                  {
                    trucks.map(({ label, value }) => (
                      <MenuItem key={value} value={value}>{label}</MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
              <TextField type="number" fullWidth label="Capacidad *" name="capacity" value={capacity} onChange={handleInputOnChange} />
              <TextField type="text" fullWidth label="Carga *" name="cargoInsurance" value={cargoInsurance} onChange={handleInputOnChange} />
              <TextField type="text" fullWidth label="Responsabilidad *" name="civilLiabilityInsurance" value={civilLiabilityInsurance} onChange={handleInputOnChange} />
              <TextField type="text" fullWidth label="Medio Ambiente *" name="environmentalInsurance" value={environmentalInsurance} onChange={handleInputOnChange} />
              <FormRow>
                <TextField style={{ marginRight: 5 }} type="text" fullWidth label="Placas *" name="plates" value={plates} onChange={handleInputOnChange} />
                <TextField type="text" fullWidth label="Modelo *" name="model" value={model} onChange={handleInputOnChange} />
              </FormRow>
              <TextField type="text" fullWidth label="Permiso SCT *" name="permissionSCT" value={permissionSCT} onChange={handleInputOnChange} />
              <TextField type="text" fullWidth label="Licencia *" name="license" value={license} onChange={handleInputOnChange} />
              <TextField type="number" fullWidth label="Compartimiento *" name="compartmen" value={compartmen} onChange={handleInputOnChange} />
              <FormRow>
                <FormControl style={{ marginRight: 5 }} fullWidth>
                  <InputLabel>Tipo Servicio *</InputLabel>
                  <Select
                    id="demo-simple-select-outlined"
                    value={typeofService}
                    onChange={(e) => handleSelecTypeService(e.target.value)}
                    label="Tipo Servicio *"
                  >
                    <MenuItem value="">
                      <em>Seleccione el servicio</em>
                    </MenuItem>
                    {
                      typeServiceGas.map(({ label, value }) => (
                        <MenuItem key={value} value={value}>{label}</MenuItem>
                      ))
                    }
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel>Permiso Unidad *</InputLabel>
                  <Select
                    id="demo-simple-select-outlined"
                    value={permission}
                    onChange={(e) => handleSelectPermission(e.target.value)}
                    label="Permiso Unidad *"
                  >
                    <MenuItem value="">
                      <em>Seleccione el permiso</em>
                    </MenuItem>
                    {
                      permissionTruck.map(({ label, value }) => (
                        <MenuItem key={value} value={value}>{label}</MenuItem>
                      ))
                    }
                  </Select>
                </FormControl>
              </FormRow>
              <FormControl fullWidth>
                <InputLabel>Codigo de unidad *</InputLabel>
                <Select
                  id="demo-simple-select-outlined"
                  value={codeUnit}
                  onChange={(e) => handleSelectUnitCode(e.target.value)}
                  label="Codigo de unidad *"
                >
                  <MenuItem value="">
                    <em>Seleccione el código</em>
                  </MenuItem>
                  {
                    trailerCode.map(({ label, value }) => (
                      <MenuItem key={value} value={value}>{label}</MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Box>
          </Box>
          <Box marginTop={10}>
            <RegularButton color="info" onClick={handleSubmit} className={classes.registerButton}>
              {
                addshipperTruckMode
                  ? "Agregar"
                  : "Guardar"
              }
            </RegularButton>
            <RegularButton color="danger" onClick={handleClose} className={classes.registerButton}>Cancelar</RegularButton>
          </Box>
        </GridItem>
      </FormContainer>
      <Snackbar
        place="tr"
        open={openValues}
        closeNotification={clearSnackbar}
        close
      />
    </>
  );
};
